import { render, staticRenderFns } from "./GroupDialog.vue?vue&type=template&id=0dea8ddc&scoped=true"
import script from "./GroupDialog.vue?vue&type=script&lang=js"
export * from "./GroupDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupDialog.vue?vue&type=style&index=0&id=0dea8ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea8ddc",
  null
  
)

export default component.exports